module.exports = __webpack_public_path__ + "static/media/aryaman.afb50b74.jpeg";